// Helper for styled() components to avoid forwarding transient styling props
// We hide any prop starting with `$` (convention) and selected known internal boolean flags
// to prevent React warnings like: Received `true` for a non-boolean attribute `light`.
const INTERNAL_TRANSIENT_PROPS = new Set(["strong", "scaleDown", "light", "withoutScale"]);

export const styledOmitPropsOptions = {
    shouldForwardProp: (propName: string) => !propName.startsWith("$") && !INTERNAL_TRANSIENT_PROPS.has(propName),
};
